import { createSelector } from 'reselect';

import { findIntercom, getFilteredMenuItems } from '@r1-frontend/entities/stores/city/actions/menu';
import { selectNewMenuItems } from '@r1-frontend/entities/stores/city/selectors/selectMenu';

export const selectHasIntercom = createSelector(selectNewMenuItems, menuItems => {
    if (!menuItems) {
        return false;
    }
    const { authMain = [], unauthMain = [] } = menuItems;
    return !!(getFilteredMenuItems([...authMain, ...unauthMain], findIntercom).length);
});
